export default {
  import_jobs: `/v2/import_jobs`
};
